"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _reactGa = _interopRequireDefault(require("react-ga4"));
var _history = require("history");
var _config = _interopRequireWildcard(require("../../config.js"));
var _this = void 0;
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var _default = exports["default"] = {
  init: function init() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var gaConfig = _objectSpread({
      debug: _config.DEBUG
    }, options);
    if (options.useSecureCookie) {
      gaConfig.gaOptions = {
        cookieFlags: 'SameSite=None;Secure',
        siteSpeedSampleRate: 100
      };
    }
    _reactGa["default"].initialize(_config["default"].googleAnalytics, gaConfig);
    (0, _history.createBrowserHistory)().listen(function (location) {
      _reactGa["default"].set({
        page: location.pathname
      });
      _this.trackPageView(location.pathname);
    });
  },
  trackEvent: function trackEvent(category, action, label, value) {
    var otherProperties = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};
    _reactGa["default"].event(_objectSpread({
      category: category,
      action: action,
      label: label,
      value: value
    }, otherProperties));
  },
  trackPageView: function trackPageView(page) {
    _reactGa["default"].set({
      page: page
    });
    _reactGa["default"].send({
      hitType: 'pageview',
      page: page
    });
  },
  setUserId: function setUserId(userId) {
    _reactGa["default"].gtag('set', 'user_properties', {
      userId: userId
    });
  },
  setCustomDimension: function setCustomDimension(dimension, value) {
    _reactGa["default"].gtag('set', 'user_properties', (0, _defineProperty2["default"])({}, dimension, value));
  }
};